import produce from 'immer';
import set from 'lodash/set';

import { MappingSetState } from '../components/shared/types';
import { Action } from './editActions';
import { createInitialPackMappingState } from './editConstants';

const editReducer = produce((draft: MappingSetState, action: Action) => {
  switch (action.type) {
    case 'REHYDRATE_MAPPING_SET': {
      return action.payload;
    }

    case 'REHYDRATE_PACK_CALCULATOR': {
      const mapping = draft.mappings.find(mapping => mapping.retrievedPackCalculatorId === action.payload.id);
      mapping!.packCalculator = action.payload;

      return draft;
    }

    case 'REHYDRATE_PACK_CALCULATOR_LIST': {
      const mapping = draft.mappings.find(mapping => mapping.id === action.payload.mappingId);
      mapping!.packCalculatorList = action.payload.packCalculatorList;

      return draft;
    }

    case 'REHYDRATE_ATTRIBUTE_MODEL': {
      const mapping = draft.mappings.find(mapping => mapping.id === action.payload.mappingId);
      mapping!.attributeModel = action.payload.data;

      return draft;
    }

    case 'ADD_PACK_MAPPING': {
      draft.mappings.push(createInitialPackMappingState());
      return draft;
    }

    case 'REMOVE_PACK_MAPPING': {
      const { mappingId } = action.payload;
      const index = draft.mappings.findIndex(mapping => mapping.id === mappingId);
      draft.mappings.splice(index, 1);
      return draft;
    }

    case 'EDIT_MAPPING_SET': {
      const { field, value } = action.payload;
      set(draft, field, value);
      return draft;
    }

    case 'EDIT_MAPPING': {
      const { mappingId, field, value } = action.payload;
      const mapping = draft.mappings.find(mapping => mapping.id === mappingId);
      set(mapping!, field, value);
      return draft;
    }

    case 'EDIT_PACK_CALCULATOR': {
      const { mappingId, field, value } = action.payload;
      const mapping = draft.mappings.find(mapping => mapping.id === mappingId);
      set(mapping!.packCalculator, field, value);
      return draft;
    }

    case 'EDIT_PACK_CALCULATOR_IN_LIST': {
      const { mappingId, calculatorIndex, field, value } = action.payload;
      const mapping = draft.mappings.find(mapping => mapping.id === mappingId);
      if (mapping && mapping.packCalculatorList && mapping.packCalculatorList[calculatorIndex]) {
        set(mapping.packCalculatorList[calculatorIndex], field, value);
      }
      return draft;
    }

    case 'ADD_PACK_CALCULATOR_TO_LIST': {
      const { mappingId, packCalculator } = action.payload;
      const mapping = draft.mappings.find(mapping => mapping.id === mappingId);
      if (mapping) {
        if (!mapping.packCalculatorList) {
          mapping.packCalculatorList = [];
        }
        mapping.packCalculatorList.push(packCalculator);
      }
      return draft;
    }

    case 'REMOVE_PACK_CALCULATOR_FROM_LIST': {
      const { mappingId, calculatorIndex } = action.payload;
      const mapping = draft.mappings.find(mapping => mapping.id === mappingId);
      if (mapping && mapping.packCalculatorList) {
        mapping.packCalculatorList.splice(calculatorIndex, 1);
      }
      return draft;
    }

    case 'MOVE_MAIN_PACK_CALCULATOR_TO_LIST': {
      const { mappingId } = action.payload;
      const mapping = draft.mappings.find(mapping => mapping.id === mappingId);
      if (mapping) {
        if (!mapping.packCalculatorList) {
          mapping.packCalculatorList = [];
        }
        // Move the main pack calculator to the list
        mapping.packCalculatorList.push(mapping.packCalculator);
      }
      return draft;
    }

    case 'UPDATE_TEST_KEY': {
      const { mappingIndex, mainKey, listKeys } = action.payload;
      const mapping = draft.mappings[mappingIndex];
      if (mapping) {
        // Update main pack calculator testKey
        mapping.packCalculator.testKey = mainKey;

        // Update list pack calculators testKeys
        if (mapping.packCalculatorList && listKeys.length > 0) {
          listKeys.forEach((key, index) => {
            if (mapping.packCalculatorList![index]) {
              mapping.packCalculatorList![index].testKey = key;
            }
          });
        }
      }
      return draft;
    }

    default: {
      return draft;
    }
  }
});

export default editReducer;
